export default {
    lang: {
        name: 'Community rating disparity'
    }
}